import type {PaymentWay} from '@rocket-ui/lk-api';

export type ProfilePaymentMethod = Extract<
	PaymentWay['type'],
	'sbp_account' | 'bank_card' | 'executor_account'
>;

export type PaymentMethodOption = {
	value: ProfilePaymentMethod;
	label: string;
};

export const PAYMENT_METHOD_OPTIONS: PaymentMethodOption[] = [
	{value: 'sbp_account', label: 'По номеру телефона (СБП)'},
	{value: 'bank_card', label: 'По номеру карты'},
	{value: 'executor_account', label: 'По номеру счёта'},
];
